import React from 'react';
import Button from './Button';
import { useLanguage } from '../../contexts/LanguageContext';

function ModalFooter({ children, className = '' }) {
  return (
    <div className={`ios-modal-footer ${className}`.trim()}>
      {children}
    </div>
  );
}

export function ModalActions({
  onCancel,
  onConfirm,
  cancelLabel,
  confirmLabel,
  loading = false,
  confirmVariant = 'primary',
  initialFocus = false,
}) {
  const { t } = useLanguage();
  const resolvedCancel = cancelLabel || t.common?.cancel || 'Cancel';
  const resolvedConfirm = confirmLabel || t.common?.confirm || 'Confirm';

  return (
    <ModalFooter>
      <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        {onCancel ? (
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            {resolvedCancel}
          </Button>
        ) : null}
        {onConfirm ? (
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            loading={loading}
            data-modal-initial-focus={initialFocus ? 'true' : undefined}
          >
            {resolvedConfirm}
          </Button>
        ) : null}
      </div>
    </ModalFooter>
  );
}

export default ModalFooter;
